export const sendMail = () => {
  window.location.href =
    'mailto:community@evqlabs.com?subject=Subject&body=Description';
};
